<app-dialog
  [dialogType]="dialogType"
  [overflowHack]="true"
  [headerLabel]="headerLabel"
  [primaryActionText]="dialogButtonText"
  [primaryActionDisabled]="numberOfSelectedTimeEntries === 0"
  [hideActions]="false"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTapped]="addBulkAction"
  [primaryActionTrackingAdditionalProperties]="
    timeEntriesMultipleSelectTrackingProperties
  "
  (onPrimaryAction)="saveSelectedTimeEntries()"
  (onCloseAction)="onClose()"
>
  <div id="time-entry-picker-dialog">
    <app-search
      class="search"
      [placeholder]="'LABEL.SEARCH' | translate"
      [actionTriggers]="searchActionTriggers$"
      (onSearchTermChange)="onSearch($event)"
    >
    </app-search>

    <div class="results-wrapper">
      <div *ngIf="boostedClientName" class="boosted-results-wrapper">
        <app-labeled-section
          [header]="boostedClientName"
          [metadata]="'ACTION.SELECT_ALL' | translate"
          [items]="boostedTimeEntries$ | async"
          [trackByFn]="trackByFn"
          (onMetadataClick)="selectAllBoostedTimeEntries()"
        >
          <ng-template let-timeEntry="labeledSectionItem">
            <app-picker-dialog-list-item
              [bulkActionControl]="getBulkActionControl(timeEntry)"
              bulkActionFieldId="bulk_select_{{ timeEntry.id }}_field"
              [showHeader]="true"
              [header]="
                timeEntry.hasValidClient()
                  ? timeEntry.billingName
                  : ('TRACKED_TIME.DELETED_CLIENT' | translate)
              "
              [description]="timeEntry.notes"
              [subDescription]="
                (isAppointment$ | async)
                  ? getAppointmentSubDescription(timeEntry)
                  : (timeEntry.duration | friendlyDuration) +
                    ' - ' +
                    (timeEntry.startDate | friendlyDate)
              "
              (onClickListItem)="onClickTimeEntry(timeEntry)"
            >
            </app-picker-dialog-list-item>
          </ng-template>
        </app-labeled-section>
      </div>

      <app-feed
        class="feed scroll-container"
        [feed]="filteredTimeEntries$ | async"
        [noItemsOptions]="noTimeEntriesOptions"
        [groupByFn]="groupByFn"
        [trackByFn]="trackByFn"
      >
        <ng-template let-timeEntry="feedItem">
          <app-picker-dialog-list-item
            [bulkActionControl]="getBulkActionControl(timeEntry)"
            bulkActionFieldId="bulk_select_{{ timeEntry.id }}_field"
            [showHeader]="true"
            [header]="
              timeEntry.hasValidClient()
                ? timeEntry.billingName
                : ('TRACKED_TIME.DELETED_CLIENT' | translate)
            "
            [description]="timeEntry.notes"
            [subDescription]="
              (isAppointment$ | async)
                ? getAppointmentSubDescription(timeEntry)
                : (timeEntry.duration | friendlyDuration) +
                  ' - ' +
                  (timeEntry.startDate | friendlyDate)
            "
            (onClickListItem)="onClickTimeEntry(timeEntry)"
          >
          </app-picker-dialog-list-item>
        </ng-template>
      </app-feed>
    </div>

    <div *ngIf="error" class="error">
      <span>{{ error }}</span>
    </div>
  </div>
</app-dialog>
